import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseConfigured = Boolean(url && anonKey);
if (!supabaseConfigured) {
  console.warn(
    "[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not set — copy .env.example to .env.",
  );
}

// Sessions persist in localStorage, which survives PWA restarts and Capacitor's WebView alike.
// Typed Database generic arrives once `supabase gen types` is wired into CI.
export const supabase = createClient(
  url ?? "http://localhost:54321",
  anonKey ?? "anon-key-not-set",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  },
);
